import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { ServicesModule } from './services/services.module';
import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import {
  authInterceptor,
  provideAuth,
  withAppInitializerAuthCheck,
} from 'angular-auth-oidc-client';

import { authConfig } from './services/auth/auth.config';
import { ToastrModule } from 'ngx-toastr';

import { authErrorInterceptor } from './core/interceptors/auth-error.interceptor';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    NavbarComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,
    ServicesModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      // Enable tap to dismiss and extended timeout options
      tapToDismiss: true,
      extendedTimeOut: 1000, // Time to show after hover ends
      // Set to 0 to make all toasts persistent by default
      // timeOut: 0, // Uncomment to make ALL toasts persistent
    }),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  providers: [
    provideHttpClient(
      withInterceptors([
        authInterceptor(),
        authErrorInterceptor
      ])
    ),
    provideAuth(authConfig, withAppInitializerAuthCheck()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
